//----------------------------------
//授权检测
const useAuthStore=()=>{
    console.log('RUN useAuthStore');
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    return {
        isAuthenticated:isAuthenticated,
    };
}
//----------------------------------
//处理数据
const fetchData=async ()=>{
    console.log('RUN fetchData');
        // const response = await fetch('https://api.example.com/data');
        // return await response.json();
    //
    // // 使用这个异步函数
     return new Promise((resolve,reject)=>{
        const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
        if(isAuthenticated)
        {
            reject(false);
        }
        else
        {
            setTimeout(()=>{
                resolve('true')
            },1000)

        }
     })

}
//----------------------------------
export {useAuthStore,fetchData}